import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React, { useContext } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { BundleContext } from '../../../bundle-context';
import { Checkbox } from 'ui-components/components/checkbox';

import style from '../../../style.module.less';
import bundleStyle from './style.module.less';
import { messages } from './messages';
import { BundleComponentsTable } from './bundle-component-table';
import { MultiActionButton } from 'ui-components/components/button/multi-action-button';

export const ProductDetailsBundle = () => {
  const { shouldShowBundleOnPackingSlip, setShouldShowBundleOnPackingSlip, addBundleComponent } = useContext(BundleContext);

  return (
    <>
      <div className={style['shipping-defaults-header-wrapper']}>
        <div className={classnames(style['shipping-defaults-header-text'])}>
          <FormattedMessage {...messages.productBundleComponentsTitle} />
        </div>
      </div>
      <div className={bundleStyle['options-plus-add']}>
        <Checkbox
          checked={shouldShowBundleOnPackingSlip ?? true}
          label={<FormattedMessage {...messages.showBundleOnPackingSlip} />}
          onChange={setShouldShowBundleOnPackingSlip}
        />
        <MultiActionButton buttonSize='normal' onClick={addBundleComponent} theme='secondary'>
          <div className={style['add-component-button']}>
            <FormattedMessage
              {...messages.productBundleComponentAdd}
              values={{
                icon: <FontAwesomeIcon className={style.icon} icon={faPlus} />,
                span: (chunks) => <span className={style['add-item-button-text']}>{chunks}</span>,
              }}
            />
          </div>
        </MultiActionButton>
      </div>
      <BundleComponentsTable />
    </>
  );
};
